import React, {useState} from 'react'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { useForm } from "react-hook-form"
import Form from 'react-bootstrap/Form';
import Alert from 'react-bootstrap/Alert';
import Card from 'react-bootstrap/Card';
import ListGroup from 'react-bootstrap/ListGroup';
import InputGroup from 'react-bootstrap/InputGroup';
import Button from 'react-bootstrap/Button';
import { ApiUrl, Headers } from '../services/ApiUrl'
import axios from 'axios'
import { useNavigate } from 'react-router-dom'

const RegistrarUsuarioProyectos = () => {
    const[showInput, setShowInput]= useState(false);
    const[existeUserMsg, setExisteUserMsg]= useState(false);
    const[existeUserMail, setExisteUserMail]= useState("");
    const[existeUserDNI, setExisteUserDNI]= useState("");
    const[existeUser, setExisteUser]= useState(false);
    const [visible, setIsVisible] = useState(false);

    const {
        register,
        handleSubmit,
        watch,
        formState: { errors },
      } = useForm()

      const navigate = useNavigate();
      const navegarTo = (destino) => {
          const destinourl = '/' + destino;
          navigate(destinourl);
      }        

    const consultarDNIexiste = async()=>{
        let url = ApiUrl + 'users_proyectos?select=*&linkTo=dni&equalTo='+watch('dni');
        axios.get(url, 
            {headers:Headers},
            ) 
            .then( response =>{   
              setExisteUserMsg("Error: el DNI ya está registrado") 
              setExisteUserDNI(true)
              setExisteUser(true)
              return
             
            }).catch( error=>{
              setExisteUserMsg("") 
              setExisteUserDNI(false)    
              setExisteUser(false)          
            }) 
    }  
    
    const consultarmailexiste = async()=>{
        let url = ApiUrl + 'users_proyectos?select=*&linkTo=email_user&equalTo='+watch('email_user');
        axios.get(url, 
            {headers:Headers},
            ) 
            .then( response =>{  
              setExisteUserMsg("Error: el mail ya está registrado") 
              setExisteUserMail(true)
              setExisteUser(true)
              return
                              
             
            }).catch( error=>{
              //console.log(error)
              setExisteUserMsg("") 
              setExisteUserMail(false)   
              setExisteUser(false)           
            }) 
    }  


    const onSubmit = (data) => {
        //console.log(data)  
        // tengo que controlar que no exista el mail ni dni
        
        if(!existeUserMail && !existeUserDNI){          
            let url = ApiUrl + 'users_proyectos?register=true&suffix=user';
            axios.post(url, data,
            {headers:Headers},
            ) 
            .then( response =>{  
                //console.log(response)  
                setIsVisible(true);
                document.getElementById("button-registrarme").disabled = true;
                setTimeout(function() {
                    navegarTo('iniciarsesionproyectos')   
                }, 5000);
                                             
            
            }).catch( error=>{
                //console.log(error)
                Alert("Error al registrar el usuario, intente nuevamente")
                document.getElementById("button-registrarme").disabled = false;
            })    
        }                              
    }
  return (
    <div>
    <Form onSubmit={handleSubmit(onSubmit)}>

        <Container style={{marginTop:'50px'}}>
            <Row>
                    <Col>  
                        <h1>Registro de usuarios para carga de proyectos</h1>
                        <p style={{fontSize:'20px'}} >Para poder cargar un proyecto es necesario registrarse en la plataforma. <br/>
                        Si ya está registrado puede iniciar sesión
                        <Button variant='outline-primary' style={{marginLeft:'8px', marginTop:'3px'}} onClick={()=>navegarTo('iniciarsesionproyectos')}>Iniciar sesión</Button>
                        </p>
                    </Col>
            </Row>
            <Row  style={{marginTop:'30px'}}>
                <Col>   
                    <Card>
                        <Card.Header><strong>Registro de usuario</strong></Card.Header>
                        <Card.Body> 
                            <ListGroup className="list-group-flush">


                                <ListGroup.Item>
                                    <Form.Group className="mb-3">
                                    <Form.Label size="lg">Nombre y apellido</Form.Label>
                                    <Form.Control type="text" placeholder="Nombre y apellido..." 
                                    {...register("name_user", 
                                    {required:"El nombre y apellido del responsable son obligatorios", 
                                    minLength:{value:5, message: "El mínimo de caracteres para el nombre y apellido es 5"}, 
                                    maxLength:{value:100, message: "El máximo de caracteres para el nombre y apellido es 100"}, 
                                    })} 
                                    isInvalid={errors.name_user}
                                    autoComplete='nope'
                                    maxLength='100'
                                    
                                    />
                                    {errors.name_user &&
                                    <Alert style={{marginTop:'10px' }} variant="danger">
                                        {errors.name_user?.message}
                                    </Alert>
                                    }
                                    </Form.Group>                        
                                </ListGroup.Item>   



                                <ListGroup.Item>
                                    <Form.Group className="mb-3">
                                    <Form.Label size="lg">Correo electrónico</Form.Label>
                                    <Form.Control type="text" placeholder="Correo electrónico..." 
                                    {...register("email_user", {required:"El correo electrónico es obligatorio",  
                                    pattern: {
                                        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                        message: "El formato del correo electrónico es incorrecto"
                                    }  
                                    })} 
                                    isInvalid={errors.email_user}
                                    autoComplete='nope' 
                                    onBlur={consultarmailexiste}
                                    />

                                    {errors.email_user &&
                                    <Alert style={{marginTop:'10px' }} variant="danger">
                                        {errors.email_user?.message}
                                    </Alert>
                                    }
                                    {existeUserMail &&
                                    <Alert style={{marginTop:'10px' }} variant="danger">
                                        {existeUserMsg}
                                    </Alert>
                                    }                                       
                                    </Form.Group>                        
                                </ListGroup.Item>        

                                <ListGroup.Item>
                                    <Form.Group className="mb-3">
                                    <Form.Label size="lg">Contraseña</Form.Label>
                                    <InputGroup className="mb-3">
                                    { showInput ?
                                    <Button variant="outline-secondary" id="button-addon2" onClick={()=>setShowInput(false)}>
                                        <i className="bi bi-eye-fill"></i>
                                    </Button>    
                                    :
                                    <Button variant="outline-secondary" id="button-addon2" onClick={()=>setShowInput(true)}>
                                        <i className="bi bi-eye-slash-fill"></i>
                                    </Button>                                     
                                    }                                
                                    <Form.Control type={showInput?'text':'password'} placeholder="Contraseña..." 
                                    {...register("password_user", 
                                    {required:"La contraseña es obligatoria", 
                                    minLength:{value:8, message: "El mínimo de caracteres para la contraseña es 8"}, 
                                    })} 
                                    isInvalid={errors.password_user}
                                    autoComplete='nope'
                                    maxLength='20'
                                    
                                    />
                                    
                                    </InputGroup>

                                    <Form.Text className="text-muted" muted>
                                        La contraseña debe tener entre 8 y 20 caracteres
                                    </Form.Text>    

                                    {errors.password_user &&
                                    <Alert style={{marginTop:'10px' }} variant="danger">
                                        {errors.password_user?.message}
                                    </Alert>
                                    }
                                    </Form.Group>                        
                                </ListGroup.Item>                                                               


                                <ListGroup.Item>
                                    <Form.Group className="mb-3">
                                    <Form.Label size="lg">DNI</Form.Label>
                                    <Form.Control type="text" placeholder="DNI..." 
                                    {...register("dni", 
                                    {
                                    required:"El DNI es obligatorio",  
                                    minLength:{value:7, message: "El mínimo de caracteres para el DNI es 7"}, 
                                    maxLength:{value:9, message: "El máximo de caracteres para el DNI es 9"}, 
                                    pattern:{ value: /^[0-9]+$/i, message: "Ingresar sólo números, sin espacios ni puntos"}
                                    })} 
                                    isInvalid={errors.dni}
                                    autoComplete='nope'
                                    maxLength='9'
                                    onBlur={consultarDNIexiste}
                                    />

                                    {errors.dni &&
                                    <Alert style={{marginTop:'10px' }} variant="danger">
                                        {errors.dni?.message}
                                    </Alert>
                                    }
                                    {existeUserDNI &&
                                    <Alert style={{marginTop:'10px' }} variant="danger">
                                        {existeUserMsg}
                                    </Alert>
                                    }                                       
                                    </Form.Group>                        
                                </ListGroup.Item>  


                                <ListGroup.Item>
                                    <Form.Group className="mb-3">
                                    <Form.Label size="lg">Fecha de nacimiento</Form.Label>
                                    <Form.Control type="date" placeholder="dd/mm/yyyy..." 
                                    {...register("fecha_nac",{required:"La fecha de nacimienot es obligatoria"})} 
                                    isInvalid={errors.fecha_nac}
                                    autoComplete='nope'
                                    maxLength='20'
                                    
                                    />

                                    {errors.fecha_nac &&
                                    <Alert style={{marginTop:'10px' }} variant="danger">
                                        {errors.fecha_nac?.message}
                                    </Alert>
                                    }
                                    </Form.Group>                        
                                </ListGroup.Item>  



                                <ListGroup.Item>
                                    <Form.Group className="mb-3">
                                    <Form.Label size="lg">Teléfono de contacto</Form.Label>
                                    <Form.Control type="text" placeholder="Teléfono..." 
                                    {...register("telefono",{required:"El teléfono de contacto es obligatorio"})} 
                                    isInvalid={errors.telefono}
                                    autoComplete='nope'
                                    maxLength='20'
                                    
                                    />

                                    {errors.telefono &&
                                    <Alert style={{marginTop:'10px' }} variant="danger">
                                        {errors.telefono?.message}
                                    </Alert>
                                    }
                                    </Form.Group>                        
                                </ListGroup.Item>   

                                <ListGroup.Item> 
                                    <Alert variant="success">
                                        Para poder cargar un proyecto es necesario registrarse en la plataforma.<br/>
                                        <strong><i className="bi bi-file-earmark-lock" style={{fontSize:'20px'}}></i> <a href="/pp2023/iniciarsesionproyectos">Ya estoy registrado - Iniciar sesión </a></strong>
                                    </Alert>                      
                                </ListGroup.Item>                             
 

                                
                                <ListGroup.Item>  
                                    { visible &&
                                    <Alert variant="success">
                                      El registro se realizó correctamente. Redirigiendo a <strong><i className="bi bi-file-earmark-lock" style={{fontSize:'20px'}}></i> <a href="/pp2023/iniciarsesionproyectos">Iniciar sesión </a></strong>
                                    </Alert>    
                                    }                                                         
                                    <Button id='button-registrarme' disabled={true} type="submit"style={{width:'200px'}} >Registrame</Button>
                                </ListGroup.Item>                                                           

                            </ListGroup>

                        </Card.Body>
                    </Card>                                                   
                </Col>
            </Row>
        </Container>
    </Form>
    </div>
  )
}

export default RegistrarUsuarioProyectos